/**
 * What the app does when it cannot render (cc3-mew3.1).
 *
 * Lazy.svelte calls this when the component it was asked to show could not be
 * loaded at all — typically a lazy chunk whose preload failed while the
 * vite:preloadError listener declined to reload (cooldown, blocked storage).
 * Before this existed that case threw out of `{#await}` and reached the global
 * error handler as an unhandled rejection; now it is an explicit decision.
 */
import { router } from './router.js'

export function renderFailed(error) {
  console.error('cc3: component could not be loaded', error)
  window.location.assign(router.url('/unhandled_error'))
}
